import React from 'react';
import { Collapse } from 'reactstrap';

import { useCollapse } from './context';

export function CollapseContent({ className = '', children = null }) {
  const { isOpen } = useCollapse();

  return (
    <Collapse isOpen={isOpen} className={className}>
      {children}
    </Collapse>
  );
}
